import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { MonitorSuggestService } from '../monitor-suggest-service';
import { MonitorSuggestRepository } from '../monitor-suggest-repository';

@injectable()
export class MonitorSuggestServiceImpl implements MonitorSuggestService {
    constructor(
        @inject(MonitorSuggestRepository) private _monitorSuggestRepository: MonitorSuggestRepository
    ) { }

    getMonitorRecommendList() {
        return this._monitorSuggestRepository.getMonitorRecommendList()
    }
}
